import moment, { Moment } from 'moment';

import ApiContact from 'types/api/Contact';

import Model from 'models/Model';

import { getFormattedDate } from 'utils/date';

export default class Contact implements Model {
    id: string;
    createdAt: Moment;
    createdAtDisplay: string;
    fullName: string;
    email: string;
    phone: string;
    message: string;

    constructor(data: ApiContact) {
        this.id = data.id;
        this.createdAt = data.createdAt && moment.utc(data.createdAt).local();
        this.createdAtDisplay = this.createdAt && getFormattedDate(this.createdAt);
        this.fullName = data.fullName;
        this.email = data.email;
        this.phone = data.phone;
        this.message = data.message;
    }
}